import './data-form-title.styl'

function DataFormTitle(props) {
  return (
    <label className="data-form-title">
      {props.children}
    </label>
  )
}

export default DataFormTitle
